import {HttpParams} from "@angular/common/http";
import {Inject, Injectable} from "@angular/core";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";

@Injectable({providedIn: 'root'})
export class SearchQueryParamsService {

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private config: HotelToursPageConfig) {
  }

  defaultQueryParams() {
    return new HttpParams()
      .set('currency', this.config.currencySignCode)
      .set('query-id', Date.now().toString() + Math.random().toString(36).substring(2))
      .set('query-start-time', Date.now());
  }
}
